module.exports = __webpack_public_path__ + "img/lobby_hosting_wlp2.a9d7defc.png";